import { useToast } from '@dc-shared-web/components'
import { useSvcCrunchesContext } from '@dc-shared-web/providers/SvcCrunchesProvider'
import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

type StartJobResult = {
  message: string
}

type StartJobGenChecklistParams = {
  doc_guid: string
  checklist_data_uuid?: string
  question_ref_id?: string
}

const startJobGenChecklist = async (
  apiClient: AxiosInstance,
  params: StartJobGenChecklistParams
): Promise<StartJobResult> => {
  const { data } = await apiClient.post('/api/jobs/job-gen-checklist', params)

  return data
}

export const useStartJobGenChecklist = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation(
    (mutParams: StartJobGenChecklistParams) =>
      startJobGenChecklist(apiClient, mutParams),
    {
      onSuccess: async () => {
        toast({
          variant: 'success',
          title: 'CrunchAI is regenerating a response',
          description:
            'This process takes some time to complete. Please check back later.',
        })

        await queryClient.invalidateQueries({
          queryKey: ['processingDocument'],
        })
        await queryClient.invalidateQueries({
          queryKey: ['ai-user-feedback'],
        })
        await queryClient.invalidateQueries({
          queryKey: ['Document'],
        })

        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error starting CrunchAI',
          description: 'If the issue persists, please contact support.',
        })

        params?.onError?.()
      },
    }
  )
}
